var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3552 79.6784H14.7847V74.4294H17.3008V77.1622H25.3552V79.6784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3374 77.1624H35.9982V79.6785H33.3374V77.1624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6309 13.2313H16.1147V5.32153H30.6768V7.83771H18.6309V13.2313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6592 5.32153H41.32V7.83771H38.6592V5.32153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9897 35.9204H42.6499V38.4366H39.9897V35.9204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9791 2.51617H29.3465V0H9.46289V85H28.0158V82.4838H11.9791V2.51617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3212 82.4839H32.0073V85.0001H75.8374V58.4648H73.3212V82.4839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.136 0H33.3374V2.51617H58.0938L73.3212 17.7436V54.4732H75.8374V16.7014L59.136 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0156 77.1624H30.6764V79.6785H28.0156V77.1624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3374 5.32153H35.9982V7.83771H33.3374V5.32153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7578 15.9648V45.0889H55.8819V29.1962H53.3657V42.5727H29.274V18.481H36.0709V31.785H46.5694V18.481H53.3657V25.2053H55.8819V15.9648H26.7578ZM44.0526 18.481V23.9472H38.5864V18.481H44.0526ZM38.5864 29.2688V26.4634H44.0526V29.2688H38.5864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.668 35.9204H37.3288V38.4366H34.668V35.9204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3105 35.9204H47.9713V38.4366H45.3105V35.9204Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3551 53.2151C21.7274 53.2151 18.7754 56.1671 18.7754 59.7948C18.7754 63.4231 21.7274 66.3744 25.3551 66.3744C28.9834 66.3744 31.9347 63.4231 31.9347 59.7948C31.9347 56.1671 28.9834 53.2151 25.3551 53.2151ZM25.3551 63.8582C23.1145 63.8582 21.2916 62.036 21.2916 59.7948C21.2916 57.5542 23.1145 55.7313 25.3551 55.7313C27.5956 55.7313 29.4185 57.5542 29.4185 59.7948C29.4185 62.036 27.5956 63.8582 25.3551 63.8582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.998 61.1973H66.5968V63.7134H35.998V61.1973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.998 55.8765H55.9543V58.392H35.998V55.8765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6147 55.8765H61.2755V58.392H58.6147V55.8765Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.3b1d5eef98c80c46157d4dd50423e867.svg";
export { ForwardRef as ReactComponent };